import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { formatPrice, getBaseUrl, getProvince } from '../../../utils'

import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';

import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';
import { TradeInModal } from '../../3_Organisms/Modal/TradeInModal';

export const PricePayment = ({ incentives, tradeInValue, checkTradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, setDownPaymentInput, onBlurDownPaymentInput, setTradeInInput, onBlurTradeInInput, setLoyaltyChecked, setGraduateChecked, setMilitaryChecked, setFirstTimeOwnerChecked, setFinancialInfo, title, ...props }) => {
	const summaryCalculator = new SummaryCalculator().reloadStoredData();
	const evRebates = summaryCalculator.FinancialInfo.ev_rebates;
    const { t, i18n } = useTranslation(['payments', 'general', 'summary']);
    const tradeInLink = i18n.language === "en" ? `${getBaseUrl()}/en/shopping/trade-in-estimator/?bnp=1` : `${getBaseUrl()}/fr/magasiner/Estimateur-de-la-valeur-dechange/?bnp=1`;
	const incentive_img_path = getBaseUrl() + t("payments:incentive_img");
	
	const [isTradeOpen, setIsTradeOpen] = React.useState(false);

	const gtmHelper = new GTMHelper();
	const carline = summaryCalculator.VehicleTitle;

	sessionStorage.setItem('curr_BNP_URL', 'https://' + window.location.host + window.location.pathname + window.location.hash.split('?')[0]);
	
	function isFirstTimeOwnerGreyOut() {
		// Uncheck
		if(!loyaltyChecked && !firstTimeOwnerChecked)
			return '';

		// Checked
		return !firstTimeOwnerChecked ? 'grey-out' : ''
	}

	function isLoyaltyGreyOut() {
		// Uncheck
		if(!loyaltyChecked && !firstTimeOwnerChecked)
			return '';

		// Checked
		return !loyaltyChecked ? 'grey-out' : '';
	}

	React.useEffect(()=>{
		window.addEventListener("message", async function (e) {
            if (e.data.type === "formEvent") {
                console.log(
                    `received message: ${e.data.message}`
                )
    
                // If the message 'close' is passed, close the trade-in modal
                if (e.data.message === "close") {
                    setIsTradeOpen(false);
                }
            }else if(e.data.type==='setTradeInVal'){
				checkTradeInValue(e.data.message);
				setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());
			}
        });
	},[tradeInValue])
    return (
		<div className="mz-bg--off-white mz-price-payment-container">
	        <div className="mz-price-payment desktop-center">
	            <h1 className='mz-price-payment__title'>{ReactHtmlParser(title)}</h1>
	            {incentives.incentive && incentives.incentive.value > 0?<div className="mz-price-payment__connect">
	                 <div >
	                    {/*<img src={incentive_img_path} alt="Mazda Incentives"/>*/}
						<strong>{t("current_incentive")}</strong>
	                    <Tooltip TooltipName="incentives" incentives={incentives.incentive.value}/>
	                </div>
	                <span className="mz-price-payment__discount-price">{`-${formatPrice(incentives.incentive.value)}`}</span>
				</div>:null}
	            {summaryCalculator.FinancialInfo.mazdaCashIncentive && summaryCalculator.FinancialInfo.mazdaCashIncentive > 0?<div className="mz-price-payment__connect">
	                 <div >
	                    {/*<img src={incentive_img_path} alt="Mazda Incentives"/>*/}
						<strong>{t("mazda_cash_incentive_title")}</strong>
	                    <Tooltip TooltipName="mazda_cash_incentive" incentives={summaryCalculator.FinancialInfo.mazdaCashIncentive}/>
	                </div>
	                <span className="mz-price-payment__discount-price">{`-${formatPrice(summaryCalculator.FinancialInfo.mazdaCashIncentive)}`}</span>
				</div>:null}				
				{ evRebates && evRebates.length > 0 ?
				<>
				 {evRebates[0] && evRebates[0].province==='federal'?<div className="mz-price-payment__connect">
	                 <div >
	                    {t("fed_rebate")}<sup>★</sup>
	                    <Tooltip TooltipName="ev_rebate_federal" incentives={formatPrice(evRebates[0].cash)} vehicle={carline}/>
	                </div>
	                <span className="mz-price-payment__discount-price text--green">{t("up_to")} {formatPrice(evRebates[0].cash)}</span>
	            </div>: ''}
				{evRebates[1] && evRebates[1].province==getProvince()?<div className="mz-price-payment__connect">
	                 <div >
	                    {t("prov_rebate")} ({getProvince()})<sup>★</sup>
	                    <Tooltip TooltipName={'ev_rebates_'+getProvince()} incentives={formatPrice(evRebates[1].cash)} vehicle={carline}/>
	                </div>
	                <span className="mz-price-payment__discount-price text--green">{t("up_to")} {formatPrice(evRebates[1].cash)}</span>
	            </div>:''}
				{evRebates[0] && evRebates[0].province==getProvince()?<div className="mz-price-payment__connect">
	                 <div >
	                    {t("prov_rebate")} ({getProvince()})<sup>★</sup>
	                    <Tooltip TooltipName={'ev_rebates_'+getProvince()} incentives={formatPrice(evRebates[0].cash)} vehicle={carline}/>
	                </div>
	                <span className="mz-price-payment__discount-price text--green">{t("up_to")} {formatPrice(evRebates[0].cash)}</span>
	            </div>:''}

				</> : '' }
	            <div className="mz-price-payment__trade">
	                <label>{t("trade_in")}<sup>1</sup> <a class="mz-link label text--grey"
					onClick={async (e) => {
						e.preventDefault();
						summaryCalculator.TradeInValue = 0;
						const isRetailerMode = await summaryCalculator.isRetailerMode();
						if(isRetailerMode){
							setIsTradeOpen(true);
						}else{
							window.location.href= tradeInLink;
						}
						
					}}>{t("estimate_your_trade_in_value")}</a></label>
	                <input type="text" value={tradeInValue.replace('$', '') === '0' ? '' :  tradeInValue} placeholder={t('payments:input_placeholder')} onChange={setTradeInInput} onBlur={onBlurTradeInInput} className="base trade-input" />
	            </div>
	            <div className="mz-price-payment__down">
	                <div className="mz-price-payment__label_container"><label>{t("down_payment")}<sup>2</sup></label> <Tooltip TooltipName="downpayment"/></div>
	                <input type="text" value={downPaymentValue.replace('$', '') === '0' ? '' :  downPaymentValue} placeholder={t('payments:input_placeholder')} onChange={setDownPaymentInput} onBlur={onBlurDownPaymentInput} className="base down-input" />
	            </div>
	            {incentives.first_time_owner.value ?<div className={`mz-price-payment__firsttimeowner ${isFirstTimeOwnerGreyOut()}`}>
	                <div className='mz-price-payment__checkbox'><input type="checkbox" className={`${isFirstTimeOwnerGreyOut()}`} checked={firstTimeOwnerChecked} onChange={()=>{
						setFirstTimeOwnerChecked(!firstTimeOwnerChecked); 
						gtmHelper.setGTM({'action':'Checkbox', 'type': 'FirstTimeOwner', 'value': firstTimeOwnerChecked}, true , false);
					}} id="firstTimeOwner" /><div className="mz-price-payment__label_container"><label id="labelFirstTimeOwner" className={isFirstTimeOwnerGreyOut()} htmlFor="firstTimeOwner">{ReactHtmlParser(t("mazda_first_time_owner_checkbox_title"))}</label> <Tooltip TooltipName="first_time_owner"/></div></div>
	                {firstTimeOwnerChecked?<span className="mz-price-payment__discount-price">{`-${formatPrice(incentives.first_time_owner.value)}`}</span>:null}
	            </div>:null}
				
	            {incentives.loyalty ?<div className={`mz-price-payment__loyalty`} >
	                <div className='mz-price-payment__checkbox'><input type="checkbox" className={isLoyaltyGreyOut()} checked={loyaltyChecked} onChange={()=>{
						setLoyaltyChecked(!loyaltyChecked);
						gtmHelper.setGTM({'action':'Checkbox', 'type': 'Loyalty', 'value': loyaltyChecked}, true , false);
					}} id="loyalty" /><div className="mz-price-payment__label_container"><label className={isLoyaltyGreyOut()} htmlFor="loyalty">{loyaltyChecked ? ReactHtmlParser(t("mazda_owner_loyalty_program_with_subtitle")) : t("mazda_owner_loyalty_program")}</label> <Tooltip TooltipName="ownerloyaltyprogram" incentives={formatPrice(incentives.loyalty.cash_value)} rate={`${formatPrice(incentives.loyalty.rate_value * 100, true).replace('$', '')}`}/></div></div>
	            </div>:null}
	            {incentives.grad_award?<div className="mz-price-payment__graduate">
	                <div className='mz-price-payment__checkbox'><input type="checkbox" checked={graduateChecked} onChange={()=>{
						setGraduateChecked(!graduateChecked);
						gtmHelper.setGTM({'action':'Checkbox', 'type': 'Graduate', 'value': graduateChecked}, true , false);
					}} id="graduate" /><div className="mz-price-payment__label_container"><label htmlFor="graduate">{t("mazda_graduate_program_award")}</label> <Tooltip TooltipName="graduate"/></div></div>
	                {graduateChecked?<span className="mz-price-payment__discount-price">{`-${formatPrice(incentives.grad_award.value)}`}</span>:null}
	            </div>:null}
	            {incentives.military?<div className="mz-price-payment__military">
	                <div className='mz-price-payment__checkbox'><input type="checkbox" checked={militaryChecked} onChange={()=>{
						setMilitaryChecked(!militaryChecked);
						gtmHelper.setGTM({'action':'Checkbox', 'type': 'Military', 'value': militaryChecked}, true , false);
					}} id="military" /><div className="mz-price-payment__label_container"><label htmlFor="military">{t("mazda_military_program")}</label> <Tooltip TooltipName="military"/></div></div>
	                {militaryChecked?<span className="mz-price-payment__discount-price">{`-${formatPrice(incentives.military.value)}`}</span>:null}
	            </div>:null}
			</div>
			<TradeInModal isOpen={isTradeOpen} checkTradeInValue={checkTradeInValue} handleClose={setIsTradeOpen} setFinancialInfo={setFinancialInfo}></TradeInModal> 
        </div>
    )
}

PricePayment.propTypes = {
    setMoneyInput: PropTypes.func,
    setLoyaltyChecked: PropTypes.func,
    setGraduateChecked: PropTypes.func,
    setMilitaryChecked: PropTypes.func,
	setFirstTimeOwnerChecked: PropTypes.func
}

PricePayment.defaultProps = {
    setMoneyInput: () => {},
    setLoyaltyChecked: () => {},
    setGraduateChecked: () => {},
    setMilitaryChecked: () => {},
	setFirstTimeOwnerChecked: () => {}
}